module.exports = __webpack_public_path__ + "static/logo-text-0e82cd3dd5c55fefee1e14bfd2ee407c.jpg";